import mascote from '@/assets/mm-hays/mascote.webp';
import { cn } from '@/lib/utils';

/**
 * O rosto do MM Hays no tamanho de um ícone de menu (pedido da Ingrid, 11/10/2026): no lugar de um
 * `Sparkles` genérico, o item do chat mostra **quem** você vai procurar. O agente é uma persona, e persona
 * se reconhece pela cara.
 *
 * Duas decisões que o tamanho impõe:
 *
 * - **Recorte no rosto.** A arte é um retrato de corpo visível sobre uma estante; a 20 px, inteira, viraria
 *   uma mancha escura. O `scale` com `overflow-hidden` aproxima na cabeça, e o `object-top` mantém o
 *   enquadramento no alto — é o mesmo gesto de um avatar de perfil, não um redimensionamento.
 * - **Redondo, com um anel tênue.** Entre ícones de traço, uma miniatura quadrada de ilustração some no
 *   fundo; o círculo e a borda dão a ela a mesma presença visual que as linhas dos vizinhos têm.
 *
 * `aria-hidden` sempre: o rótulo "MM Hays" está ao lado, e um `alt` aqui faria o leitor de tela dizer o nome
 * duas vezes. Para o avatar da conversa, com `alt`, é o `AvatarMmHays`.
 */
export function IconeMmHays({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex size-5 shrink-0 overflow-hidden rounded-full ring-1 ring-border',
        className,
      )}
    >
      <img src={mascote} alt="" className="size-full scale-[1.45] object-cover object-top" />
    </span>
  );
}
